
import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useBoardContext } from '@/contexts/BoardContext';

interface AssignmentSectionProps {
  assignedUserId: string | null;
  onAssignedUserChange: (userId: string | null) => void;
}

export const AssignmentSection = ({ 
  assignedUserId, 
  onAssignedUserChange 
}: AssignmentSectionProps) => {
  const { profiles } = useBoardContext();

  return (
    <div className="space-y-2">
      <label className="text-sm font-medium">Assigned User</label>
      <Select
        value={assignedUserId || 'unassigned'}
        onValueChange={(value) => 
          onAssignedUserChange(value === 'unassigned' ? null : value)
        }
      >
        <SelectTrigger>
          <SelectValue placeholder="Select a user" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="unassigned">Unassigned</SelectItem>
          {profiles?.map((profile) => (
            <SelectItem key={profile.id} value={profile.id}>
              {profile.full_name || profile.username || 'Unnamed User'}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
